import * as actions from '../actions/types'

const initialState = {
  degrees: [],
  licenses: [],
  certificates: [],
  workExperience: {
    license: {
      hasWorkHours: false
    },
    certificate: {
      hasWorkHours: false
    }
  },
  otherLicenseOrCert: {
    hasOtherLicenseOrCert: false
  },
  hasOtherWorkHours: false,
  hasVolunteerHours: false
};

function updateProfessionalInfo(professionalState, action){
  return {
    ...professionalState,
    ...action.updates
  };
}

function setProfessionalInfo(professionalState, action){
  return {
    ...professionalState,
    ...action.application.professional
  };
}

function addDegree(professionalState, action){
  return {
    ...professionalState,
    degrees: [...professionalState.degrees, action.newDegree]
  };
}

function removeDegree(professionalState, action){
  return {
    ...professionalState,
    degrees: professionalState.degrees.filter(degree => action.degreeId !== degree.id)
  };
}

function updateDegree(professionalState, action){
  return {
    ...professionalState,
    degrees: professionalState.degrees.map((degree) => {
      if(action.degreeId !== degree.id)
        return { ...degree };
      return {
        ...degree,
        ...action.updates
      };
    })
  };
}

function addLicense(professionalState, action){
  return {
    ...professionalState,
    licenses: [...professionalState.licenses, action.newLicense]
  };
}

function removeLicense(professionalState, action) {
  return checkForEmptyLicenseList({
    ...professionalState,
    licenses: professionalState.licenses.filter(license => action.licenseId !== license.id)
  });
}

function checkForEmptyLicenseList(professionalState) {
  if(professionalState.licenses.length > 0)
    return professionalState;
  // If no licenses are left, zero out work experience
  return {
    ...professionalState,
    workExperience: {
      ...professionalState.workExperience,
      license: {
        hasWorkHours: false
      }
    }
  }
}

function updateLicense(professionalState, action){
  return {
    ...professionalState,
    licenses: professionalState.licenses.map((license) => {
      if(action.licenseId !== license.id)
        return { ...license };
      return {
        ...license,
        ...action.updates
      };
    })
  };
}

function addCertificate(professionalState, action){
  return {
    ...professionalState,
    certificates: [...professionalState.certificates, action.newCertificate]
  };
}

function removeCertificate(professionalState, action){
  return checkForEmptyCertificateList({
    ...professionalState,
    certificates: professionalState.certificates.filter(certificate => action.certificateId !== certificate.id)
  });
}

function checkForEmptyCertificateList(professionalState) {
  if(professionalState.certificates.length > 0)
    return professionalState;
  // If no certificates are left, zero out work experience
  return {
    ...professionalState,
    workExperience: {
      ...professionalState.workExperience,
      certificate: {
        hasWorkHours: false
      }
    }
  }
}

function updateCertificate(professionalState, action){
  return {
    ...professionalState,
    certificates: professionalState.certificates.map((certificate) => {
      if(action.certificateId !== certificate.id)
        return { ...certificate };
      return {
        ...certificate,
        ...action.updates
      };
    })
  };
}

function applicationDeleted() {
  return initialState;
}

export const professionalInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.UPDATE_PROFESSIONAL_INFO: return updateProfessionalInfo(state, action);
    case actions.SET_APPLICATION:
    case actions.REFRESH_APPLICATION:
      return setProfessionalInfo(state, action);
    case actions.ADD_DEGREE: return addDegree(state, action);
    case actions.REMOVE_DEGREE: return removeDegree(state, action);
    case actions.UPDATE_DEGREE: return updateDegree(state, action);
    case actions.ADD_LICENSE: return addLicense(state, action);
    case actions.REMOVE_LICENSE: return removeLicense(state, action);
    case actions.UPDATE_LICENSE: return updateLicense(state, action);
    case actions.ADD_CERTIFICATE: return addCertificate(state, action);
    case actions.REMOVE_CERTIFICATE: return removeCertificate(state, action);
    case actions.UPDATE_CERTIFICATE: return updateCertificate(state, action);
    case actions.DELETE_APPLICATION_SUCCESS: return applicationDeleted(state, action);
    default: return state;
  }
};

export default professionalInfoReducer;